/**
 * A single ordering of the 169 starting hands, strongest first.
 *
 * Every preflop range in this file is a slice of this list, which is the whole reason
 * it exists: one ordering means one place to argue about, and a range described as
 * "the top 22%" can be checked against it by anyone.
 *
 * Generated, not hand-written. The score is each hand's all-in equity against a random
 * hand — measured by the same Monte Carlo the bots use, so it cannot silently disagree
 * with them — plus playability adjustments that equity alone gets wrong: suitedness
 * and connectedness are worth more than a heads-up all-in shows, and small pairs are
 * worth considerably less, because most of a small pair's value is in flopping a set
 * and stacking someone, which an all-in never gets to do.
 *
 * It is a heuristic ordering for the bots. It is NOT a solve, and nothing derived from
 * it is described to a customer as GTO. The solved push/fold charts are a separate
 * thing and take precedence wherever they apply.
 */
export const HAND_ORDER: readonly string[] = [
  "AA", "KK", "QQ", "JJ", "TT", "AKs", "99", "AQs", "KQs", "AJs", "88", "AKo", "ATs",
  "KJs", "QJs", "77", "AQo", "KTs", "A9s", "QTs", "KQo", "A8s", "AJo", "JTs", "A5s", "A7s",
  "K9s", "ATo", "A6s", "KJo", "A4s", "66", "Q9s", "QJo", "A3s", "J9s", "K8s", "T9s", "KTo",
  "A2s", "A9o", "K7s", "Q8s", "QTo", "55", "K6s", "A8o", "JTo", "J8s", "K5s", "A5o", "A7o",
  "K9o", "T8s", "98s", "K4s", "Q7s", "A6o", "A4o", "K3s", "Q9o", "Q6s", "44", "J7s", "K2s",
  "A3o", "Q5s", "J9o", "K8o", "T9o", "T7s", "87s", "Q4s", "97s", "A2o", "K7o", "Q8o", "Q3s",
  "K6o", "J6s", "33", "Q2s", "J5s", "T6s", "K5o", "J8o", "76s", "96s", "T8o", "J4s", "86s",
  "98o", "K4o", "Q7o", "J3s", "K3o", "Q6o", "J2s", "J7o", "22", "K2o", "65s", "T5s", "Q5o",
  "T4s", "75s", "95s", "T7o", "87o", "85s", "Q4o", "T3s", "97o", "54s", "T2s", "Q3o", "J6o",
  "Q2o", "64s", "94s", "J5o", "T6o", "74s", "84s", "93s", "76o", "96o", "J4o", "86o", "43s",
  "92s", "53s", "J3o", "63s", "83s", "73s", "J2o", "65o", "T5o", "82s", "32s", "T4o", "95o",
  "75o", "52s", "42s", "85o", "T3o", "54o", "62s", "T2o", "72s", "64o", "94o", "74o", "84o",
  "93o", "43o", "92o", "53o", "63o", "83o", "73o", "82o", "32o", "52o", "42o", "62o", "72o",
];

/** Position of a hand in the ordering, 0 = AA. Throws on an unknown code. */
const RANK_OF: ReadonlyMap<string, number> = new Map(HAND_ORDER.map((c, i) => [c, i]));

export function handRank(code: string): number {
  const r = RANK_OF.get(code);
  if (r === undefined) throw new Error(`unknown hand code: ${code}`);
  return r;
}
